import React from 'react'
import Wizard from '@modules/form-wizard'
import SERVICE_PROPS from '@helpers/extract-service-props'
import nationalities from '@constants/nationalities'
import passportPhotoExample from '@helpers/passport-photo-example'



export default class BirthRequest extends React.Component {
  resource = '/birth_requests'
  form_key = 'birth_request'
  defaults = {}


  // Delete lines as needed
//   fee           = 99
//   free          = true
//   postpaid      = true
  skip_location = true
  hide_buttons  = false
  custom_actions = []

  coordinates = null

  validate = async values => {
    const update = {}

    update.facility = values.facility == 'other' ? values.facility_other : values.facility;

    return update
  }

  foremost = null


  fields = form => [
    "::Section 1",

    {
        name: 'island',
        options: ['New Providence', 'Grand Bahama'],
        callback: async (v) => {
            if (form.island) {
              return { facility: '' }
            }
        },
    },

    '::Applicant Information',
    {
        name: 'facility',
        options: form.island == 'New Providence' ? [
            { label: 'Princess Margaret Hospital (PMH)', value: 'Princess Margaret Hospital ' },
            { label: 'Sandilands Rehabilitation Centre (SRC)', value: 'Sandilands Rehabilitation Centre' },
            { label: 'Other', value: 'other' },
        ] : [
            { label: 'Rand Memorial Hospital (RMH)', value: 'Rand Memorial Hospital' },
            { label: 'Grand Bahama Health Services (GBHS)', value: 'Grand Bahama Health Services'},
            { label: 'Other', value: 'other' },
        ]
    },
    {
        name: 'facility_other',
        label: 'Other Facility',
        hide: form.facility != 'other',
        save: true,
        view: false,
    },
    {
        name: 'i_am_applicant',
        label: 'I am requesting this service for myself',
        type: 'select:bool',
    },
    {
        name: 'applicant_f_name',
        label: 'First Name',
        hide: form.i_am_applicant
    },
    {
        name: 'applicant_m_name',
        label: 'Middle Name',
        required: false,
        hide: form.i_am_applicant
    },
    {
        name: 'applicant_l_name',
        label: 'Last Name',
        hide: form.i_am_applicant
    },
    {
        name: 'applicant_maiden_name',
        label: 'Maiden Name',
        required: false,
    },
    {
        name: 'applicant_marital_status',
        label: 'Marital Status',
        options: [
            'single',
            'married',
            'divorced',
            'other'
        ],
    },
    {
        name: 'applicant_nationality',
        label: 'Nationality',
        options: nationalities,
    },
    {
        name: 'applicant_dob',
        label: 'Date of Birth',
        type: 'date',
        hide: form.i_am_applicant
    },
    {
        name: 'applicant_gender',
        label: 'Gender',
        options: [
            'Male',
            'Female',
        ],
        hide: form.i_am_applicant
    },
    {
        name: 'applicant_resident',
        label: 'Resident or Non-Resident',
        options: [
            'Resident',
            'Non-Resident',
        ],
        hide: form.i_am_applicant
    },
    {
        name: 'applicant_address',
        label: 'Address',
        hide: form.i_am_applicant
    },
    {
        name: 'applicant_email',
        label: 'Email Address',
        type: 'email',
        hide: form.i_am_applicant
    },
    {
        name: 'applicant_phone',
        label: 'Phone Contact',
        type: 'phone',
        hide: form.i_am_applicant
    },
    {
        name: 'applicant_phone_2',
        label: 'Phone Contact (secondary)',
        type: 'phone',
        required: false,
        hide: form.i_am_applicant
    },
    {
        name: 'applicant_employment',
        label: 'Place of Employment',
        // hide: form.i_am_applicant
    },
    {
        name: 'applicant_insurance',
        label: 'Insurance Carrier',
        required: false,
        // hide: form.i_am_applicant
    },
    {
        name: 'applicant_passport_no',
        label: 'Passport #',
        type: 'passport',
        // hide: form.i_am_applicant
    },
    {
        name: 'applicant_nib_no',
        label: 'NIB #',
        type: 'integer',
        hide: form.i_am_applicant
    },

    '::SPACER',
    "::Mother's Information",
    {
        name: 'mother_f_name',
        label: 'First Name',
    },
    {
        name: 'mother_m_name',
        label: 'Middle Name',
        required: false,
    },
    {
        name: 'mother_l_name',
        label: 'Last Name',
    },
    {
        name: 'mother_maiden_name',
        label: 'Maiden Name',
        hint: 'If never married use same Last Name',
    },
    {
        name: 'mother_address',
        label: 'Address',
    },
    {
        name: 'mother_dob',
        label: 'Date of Birth',
        type: 'date',
    },
    {
        name: 'mother_po_box',
        label: 'PO Box',
        required: false,
    },
    {
        name: 'mother_phone',
        label: 'Phone Contact',
        type: 'phone',
    },
    {
        name: 'mother_phone_2',
        label: 'Phone Contact (secondary)',
        type: 'phone',
        required: false,
    },

    // '::SPACER',
    // "::Father's Information",
    // {
    //     name: 'father_f_name',
    //     label: 'First Name',
    // },
    // {
    //     name: 'father_m_name',
    //     label: 'Middle Name',
    //     required: false
    // },
    // {
    //     name: 'father_l_name',
    //     label: 'Last Name',
    // },
    // {
    //     name: 'father_address',
    //     label: 'Address',
    // },
    // {
    //     name: 'father_dob',
    //     label: 'Date of Birth',
    //     type: 'date',
    // },
    // {
    //     name: 'father_po_box',
    //     label: 'PO Box',
    //     required: false,
    // },
    // {
    //     name: 'father_phone',
    //     label: 'Phone Contact',
    //     type: 'phone',
    // },
    // {
    //     name: 'father_phone_2',
    //     label: 'Phone Contact (secondary)',
    //     type: 'phone',
    //     required: false,
    // },
    // {
    //     name: 'expedite',
    //     label: 'I am requesting same day search',
    //     type: 'select:bool',
    // },

    '::SPACER',
    "::Uploads",

    {
        name: 'passport_upload',
        label: 'Passport ID Photo',
        type: 'file:all',
        hint: passportPhotoExample,
        key: f => f.image[0],
    },
    {
        name: 'choose_upload',
        label: "Please upload one of the following documents as an alternative form of ID",
        options: ['Birth Certificate', 'Drivers License', 'Voters Card', 'NIB Card', 'Affidavit'],
    },
    {
        name: 'alternate_id_upload',
        label: `${form.choose_upload}`,
        type: 'file:all',
        hide: form.choose_upload == null,
        key: f => f.image[1],
    },
    {
        name: 'alternate_id_number',
        label: `${form.choose_upload} #`,
        type: 'integer',
        hide: ['Affidavit', 'Birth Certificate'].includes(form.choose_upload) || form.choose_upload == null,
    },
  ]

  render = () => <Wizard {...SERVICE_PROPS(this)} />

}